"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardAttachmentPreferencesOption')(function discardAttachmentPreferencesOption(state) {
    var optionState = state.optionState;
    optionState.fromComputer = null;
    optionState.fromOneDrive = null;
}));
//# sourceMappingURL=discardAttachmentPreferencesOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/actions/discardAttachmentPreferencesOption.js
// module id = 4984
// module chunks = 2